<template>
  <hi-page>
    <hi-page-column card width="70vw" fix-width>
      <hi-row flex text-center py-md>
        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
          Today
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small>
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <v-toolbar-title v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </hi-row>

      <v-calendar
        ref="calendar"
        v-model="value"
        :weekdays="weekday"
        :type="type"
        :events="events"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
      ></v-calendar>
      <template v-slot:footer>Footer</template>
    </hi-page-column>
    <router-view></router-view>
  </hi-page>
</template>

<script>
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiPage from "@/components/scaffold/HiPage";
import HiRow from "@/components/scaffold/HiRow";

export default {
  name: "Appointments",
  components: { HiPageColumn, HiPage, HiRow },
  data() {
    return {
      type: "month",
      types: ["month", "week", "day", "4day"],
      mode: "stack",
      modes: ["stack", "column"],
      weekday: [1, 2, 3, 4, 5, 6, 0],
      value: "",
      events: []
    };
  }
};
</script>

<style scoped></style>
